import { DOCUMENT } from '@angular/common';
import { AfterViewChecked, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/user/auth.service';

@Component({
  templateUrl: 'test_iframe.html',
  selector: 'app-test-iframe',
  styleUrls: ['./test_iframe.component.css'],
})

export class TestIFrameComponent implements OnInit,AfterViewChecked {
  private destUrl: SafeUrl;
  currentURL: any;
  show = {
    iframe: false
  }
  height: 0;
  @Input() parent : HTMLElement;

  constructor (
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private cdRef:ChangeDetectorRef,
    @Inject(DOCUMENT) private document: any
  ) {


  }
  URL_old() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.activatedRoute.snapshot.data.url + '&bearer=' + this.authService.user.token);
  }
  URL() {
    this.currentURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.activatedRoute.snapshot.data.url + '&bearer=' + this.authService.user.token);
    //$('iframe').height($('body').parent().height() - $('.topbar').height() - 80);
  }
  ngAfterViewChecked(){
   this.height = this.document.body.scrollHeight;
   this.cdRef.detectChanges();
  }
  ngOnInit() {
    this.URL();
  }
}



// WEBPACK FOOTER //
// ./src/app/views/test/test_iframe.component.ts